'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.controller_device_edit', {
    url: 'controller_edit/:id',
    template: '<controller-device-edit></controller-device-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/device_config/controller_edit/controller_edit.routes.js